module.exports = __webpack_public_path__ + "static/img/2018_New_Logo.e6b1911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2018_New_Logo.png
// module id = 1kVb
// module chunks = 1